import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { removeTicketMember } from 'flow/actions/tickets-action';
import {
    selectAssignee,
    selectMembersCount,
} from 'flow/selectors/TicketsSelectors';
import { ExtensionKey, TicketKey } from 'flow/types/EntityKeys';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';
import { segmentTrack } from 'flow/actions/segment-actions';
import useTicketAction from 'flow/hooks/useTicketAction';

interface Props {
    memberKey: ExtensionKey;
    ticketKey: TicketKey;
}

const MemberContextMenu = ({ memberKey, ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const runTicketAction = useTicketAction();

    const membersCount = useAppSelector((state) =>
        selectMembersCount(state, ticketKey),
    );
    const assignee = useAppSelector((state) =>
        selectAssignee(state, ticketKey),
    );

    const removeMemberDisabled = assignee === memberKey || membersCount === 1;
    const onClickRemoveMember = (event?: React.MouseEvent) => {
        event?.stopPropagation();
        if (removeMemberDisabled) return;
        runTicketAction(removeTicketMember(ticketKey, memberKey));
        dispatch(
            segmentTrack(TICKET_STRINGS.REMOVE_MEMBER, {
                component: 'ticket details',
            }),
        );
    };

    return (
        <>
            <MenuItem
                onClick={onClickRemoveMember}
                disabled={removeMemberDisabled}
            >
                {i18next.t('Chat.Details.RemoveMember')}
            </MenuItem>
        </>
    );
};

export default MemberContextMenu;
